/**
import all locale translation from different module
and export from this file.
 **/
import homepage from '@/Homepage/langs/zh_hk'
import auth from '@/Auth/langs/zh_hk'
import error from '@/ErrorPage/langs/zh_hk'
import fitComponents from '@/components/langs/zh_hk'
import adm from '@/Adm/langs/zh_hk'
import crm from '@/Crm/langs/zh_hk'
import osm from '@/Osm/langs/zh_hk'
import my from '@/My/langs/zh_hk'
import dw from '@/Dw/langs/zh_hk'
import validation from '@/Validation/langs/zh_hk'
import quick from '@/Quick/langs/zh_hk'

export default {
  hm: '主頁',
  general: {
    batchSelect: '多項選擇',
    selectable: '可選擇',
    submit: '提交',
    add: '添加',
    remove: '刪除',
    logout: '登出',
    language: '系統語言',
    updateSuccess: '更新成功。',
    updateError: '更新失敗，請稍後再試',
    deleteSuccess: '刪除成功。',
    selectDate: '請選擇日期',
    autoSearchText: '抱歉，無匹配選項',
    ok: '是',
    cancel: '取消',
    confirm: '確認',
    notification: '提示',
    message: '訊息',
    yes: '是',
    no: '否',
    save: '儲存',
    create: '創建',
    edit: '修改',
    pagination: {
      perPage: '每頁項目',
      items: '頁數 {page} / 總共 {total} 項目'
    },
    action: '行動',

    fromDate: '開始日期',
    toDate: '結束日期',
    clearFilter: '清除選項',

    search: '檢索關鍵字',
    total: '總共',
    records: '紀錄',
    all: '所有',
    more: '更多',
    date: '日期',
    perPage: '每頁',

    M: '男',
    F: '女',

    //CURD Text
    CURD: {
      create: '創建',
      edit: '修改',
      actions: '行動',
      update: '更新',
      retrieve: '查看',
      delete: '刪除',
      approve: '批准',
      reject: '拒絕',
      next: '下一步',
      complete: '完成',
      prev: '上一步',
      deleteConfirmMessage: '確認刪除這些紀錄嗎？',
      save: '儲存'
    },
    workflow: {
      next: '下一步',
      previous: '上一步',
      finish: '完成'
    },
    gender: '性別',
    dateOfBirth: '出生日期',
    identityCardNo: '身分證號碼',
    companyAddress: '公司註冊地址',
    correspondenceAddress: '聯絡地址',
    residentialAddress: '住址',
    email: '電子郵件',
    fax: '傳真',
    telephoneMobile: '手提電話',
    telephoneHome: '住宅電話',
    telephoneOffice: '辦公室電話'
  },
  validation,
  home: homepage,
  auth,
  error,
  fitComponents,
  adm,
  osm,
  crm,
  my: my,
  dw,
  quick
}



// WEBPACK FOOTER //
// ./src/langs/zh_hk/index.js